import { Avatar } from '@material-ui/core'
import { useState,useEffect } from 'react'
import React from 'react'
import './sidebarChat.css'
import { Room } from '@material-ui/icons';
import db from './firebase';
import { Link } from 'react-router-dom';


function SidebarChat({addNewChat,id,name}) {
//we used useEffect so that whenever the sideabar component is loaded with chats we always get a new svg icon
    const[value,setValue] = useState("");
    const[messages,setMessages] = useState("");

    useEffect(()=>{
       setValue(Math.floor(Math.random()*5000));
       console.log(value);
    },[])

    useEffect(()=>{
       if(id){
        db.collection("rooms").doc(id).collection("messages").orderBy("timestamp","desc")
        .onSnapshot((snapshot) => setMessages(snapshot.docs.map((doc)=> doc.data())))
       }
    },[id])

 // we use Createchat function so that whenever user wants he can create a new chat   

    const createChat = (e)=>{
        e.preventDefault();
        const RoomName = prompt('enter name for the chart');

        if(RoomName){
            //we go to database collection of rooms and add new name as RoomName
              db.collection("rooms").add({
              name:RoomName,
            });
        }
    }
  
  return !addNewChat? (
    //if there is no addNewChat prop then we execute the down return function else we execute the or return component
    <Link to={`/rooms/${id}`}>
    <div className='sidebar_chat'>
      
        <div className='single_chat'>
           <Avatar src={`https://avatars.dicebear.com/api/human/${value}.svg`} />
           <div className='description'>
           <h5>{name}</h5>
           <p>{messages[0]?.message}</p>
           </div>
        </div>
    </div>
    </Link>
    
  ):(
       
      <div onClick={createChat}>
        <h2>Add a New Chat</h2>
      </div>
      
  
  )
}

export default SidebarChat